import { useEffect, useState } from 'react';

import auth from './index';
import { type AuthUser } from './types';

// Subscribe to the current signed-in user. Isolated from GlobalState on
// purpose — auth state lives here, not in the persisted app state.
export const useAuthUser = (): AuthUser | null => {
  const [user, setUser] = useState<AuthUser | null>(() => auth.getCurrentUser());
  useEffect(() => auth.onAuthChanged(setUser), []);
  return user;
};

export default useAuthUser;
